export default "__VITE_ASSET__MhGsSHrS__"